import React, { useEffect, useState } from "react";
import { Monitor, Volume2, Megaphone, CalendarDays, Percent, Users, Sparkles, ShieldX } from "lucide-react";
import axios from "axios";
import { Link , useNavigate, useLocation } from "react-router-dom";
import SignupModal from "./SignupModal";
import { Translator } from './translator';
import { PLAN_META } from './plans';

const BASE = "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com";

const Choose = () => {
  const [tours, setTours] = useState([]);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [showSignupModal, setShowSignupModal] = useState(false);
  const { translateText, lang } = Translator();
//  const [mode, setMode] = useState("singolo");
  const [saving, setSaving] = useState(false);
  const [packageTours, setPackageTours] = useState([]);
  const [bundleOpen, setBundleOpen] = useState(false);
  const [selectedInteressi, setSelectedInteressi] = useState([]);
  const [loadingTours, setLoadingTours] = useState(true);
  const [translating, setTranslating] = useState(false);
  const [interestsHydrated, setInterestsHydrated] = useState(false);
  const [nextMonthIds, setNextMonthIds] = useState(new Set());
  const [nextTours, setNextTours] = useState([]);
  const [fuoriCard, setFuoriCard] = useState(null);
  const [fuoriLoading, setFuoriLoading] = useState(false);
  const [fuoriError, setFuoriError] = useState(null);
  const REF_PLAN_KEY   = "ref_plan_key";         // BASIC|PLUS
  const REF_CODE_KEY   = "ref_code_raw";         // ABCD1234 (no dash)
  const REF_DISC_KEY   = "ref_discount_amount";  // 4.00 or 14.00
  const [planPreview, setPlanPreview] = useState({ open: false, planKey: null });
  const includedTours = tours.filter(t => !nextMonthIds.has(String(t.id)));
  const [packagePrice, setPackagePrice] = useState(null);
  const [packageCurrency, setPackageCurrency] = useState("EUR");
  const formatMoney = (value, currency = "EUR") =>  new Intl.NumberFormat(lang || undefined, { style: "currency", currency }).format(value);
  const originalTotal = packageTours.reduce((sum, t) => sum + Number(t.price || 0), 0);

  const baseText = {
    text1: "TecheTour",
    text2: "Sfoglia, scegli, vivi: scopri tutti i nostri tour STREAM-IMMERSION",

    textRadici: "Radici in Viaggio",

    header1: "Ogni 30 giorni rinnoviamo la nostra Offerta Culturale. Offriamo minimo 4 nuovi tour ed 1 “Fuori Rotta” esclusivi per la durata dei 30 giorni",
    header2: "Affrettati per godere ogni aspetto della tua Cultura Italiana",

    exploreTours: "Esplora i Tour",
    durationDay: "giorno",
    durationDay2: "giorni",
    discoverTour: "Scopri il tour",
    text4: "Durata consigliata",

    titlePlans: "Scegli il piano più adatto a te",
    recommended: "Consigliato",
    choosePlan: "Acquista",

    tabSingle: "Singolo",
    tabBundle: "Pacchetto",
    tabSub: "Abbonamento",
    
    
    text5: "Acquista i tour singoli al costo promozionale per il lancio!",
    text6: 'Fruisci tre tour del pacchetto "Radici Italiane" ad un prezzo scontato di €9,99 anziché €14,97. Durata 30 giorni',
    text7: "Abbonati e risparmia. Vivi tutti tour del periodo e un esclusivo “Fuori Rotta”",
    text8: "Scegli il piano abbonamento più adatto a te",
    

    text199: "loading teche tours in $lang",
    text120: "(ritento...)",


    plansFooter1: "Ti invitiamo a leggere tutte le informazioni dei piani scelto per conoscere le funzionalità incluse: ",
    basictext: "BASIC",
    plustext: "PLUS",
    plansFooter2: "Consulta i Termini d’uso per maggiori dettagli.",
    plansFooter3: "Puoi disdire l'abbonamento in qualsiasi momento o modificare il piano abbonamento.",
    textApripacchetto: "Apri pacchetto",
    toursIncluded: "tour inclusi",
    bundleName: "Radici Italiane — Pacchetto 1º",
    bundleCartBtn: "Aggiungi al carrello",
    backToBundle: "← Torna al pacchetto",


    planNameBasic: "BASIC",
    planNamePlus: "PLUS",
    priceBasic: "8,99€",
    pricePlus: "19,99€",
    basicAdLabel: "Con pubblicità",
    basicFeature1: "Accesso a tutti i nuovi tour del mese (con pubblicità).",
    basicFeature2: "Un' esclusiva sorpresa mensile “Fuori Rotta” al costo promozionale di €7,99 anziché €15,99 (con pubblicità).",

    plusAdLabel:"", // "Senza pubblicità",
    plusFeature1: "Accesso a tutti i nuovi tour del mese ",               // (senza pubblicità).
    plusFeature2: "Un' esclusiva sorpresa mensile “Fuori Rotta” gratuita",    // (senza pubblicità).
    textxxxx: "Estensioni disponibili: abbonamento fino a 4 amici/familiari al costo di €5,99 ciascuno per il primo mese",
    plusFeatureMetaverse: 'Accesso esclusivo al nostro TECHE-METAVERSE (sarà visibile nella pagina "Tour Acquistati")',
    conjunctionAnd: "e",

    tooltipLikes: "Mi piace totali",
    tooltipComments: "Commenti totali",
    tooltipViews: "Visualizzazioni totali",
    textfree: "GRATUITO",

    nextMonthTitle: "Scopri i tour del mese prossimo",
    textNextmonth: "Prossimamente",

    fuoriRottaTitle: "Fuori Rotta",
    fuoriRottaSubheading: "Esperienza esclusiva del periodo",
    textChiudi: "Chiudi",

    textNoResultsTitle: "Nessun tour trovato",
    textNoResultsBody: "Prova un altro filtro o rimuovi i filtri per vedere tutti i tour disponibili.",

    textResetFilters: "Azzera filtro",
    

    textalert: "Impossibile aggiungere il piano al carrello.",

  };

  const [translatedText, setTranslatedText] = useState(baseText);
  useEffect(() => {
    const translateAll = async () => {
      const entries = Object.entries(baseText);
      const translatedEntries = await Promise.all(
        entries.map(async ([key, value]) => [key, await translateText(value)])
      );
      setTranslatedText(Object.fromEntries(translatedEntries));
    };
  
    translateAll();
  }, [lang]);

  const bundleIds = ["101", "202", "303"];
  const bundleTours = tours.filter(t => bundleIds.includes(String(t.id)));
  const plans = [PLAN_META.BASIC, PLAN_META.PLUS];
  const INTEREST_LABELS = {
    1: "Arte, Creatività e Ciak",
    2: "Archeologia, Miti e Leggende",
    3: "Borghi, Tradizioni e Memorie",
    4: "Feste, Rituali e Devozione",
    5: "Paesaggi, Cibo e Colture",
    6: "Artigianato e Mercatini",
  };

  const [resetFilterLabel, setResetFilterLabel] = useState("Azzera filtro");
  const formatPrice = (p) => Number(p) === 0 ? (translatedText.textfree || "FREE") : `€${p}`;
  const [translatedInteressi, setTranslatedInteressi] = useState(INTEREST_LABELS);

  useEffect(() => {
    (async () => {
      const entries = Object.entries(INTEREST_LABELS);
      const translated = await Promise.all(
        entries.map(async ([id, label]) => [id, await translateText(label)])
      );
      setTranslatedInteressi(Object.fromEntries(translated));
    })();
  }, [lang, translateText]);

  
  
  useEffect(() => {
    (async () => {
      setResetFilterLabel(await translateText("Azzera filtro"));
    })();
  }, [lang, translateText]);


  const location = useLocation();
  const [mode, setMode] = useState(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    return ["singolo", "pacchetto", "abbonamento"].includes(tab) ? tab : "singolo";
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    if (["singolo", "pacchetto", "abbonamento"].includes(tab)) {
      setMode(tab);
    }
  }, [location.search]);


  const handleChoosePlan = async (planKey) => {
  const currentUser = JSON.parse(localStorage.getItem("user") || "null");
  if (!currentUser?.email) {
    sessionStorage.setItem("selected_plan", planKey);
    navigate("/CompleteRegistration", { state: { planKey } });
    return;
  }
  if (saving) return;
  setSaving(true);
  try {
    const { data } = await axios.post(`${BASE}/saveToCart`, {
      email: currentUser.email,
      planKey: planKey.toUpperCase(),
      fuoriRotta: true, // or wire this to a toggle
    });
    if (data.status !== "success") {
      alert(data.message || translatedText.textalert);
      return;
    }
    window.dispatchEvent(new Event("showCartPopup"));
    navigate("/carrello");
  } catch (err) {
    console.error("Failed to save plan to cart:", err);
  const serverMsg =
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    err?.message ||
    "Errore durante l’aggiunta al carrello.";
  alert(serverMsg);
} finally {
  setSaving(false);
}
};


const tabBtn = (key) =>
  `px-6 py-3 rounded-full font-semibold transition
   ${mode === key ? 'bg-[#324B8E] text-white' : 'text-[#324B8E] hover:bg-[#324B8E]/10'}`;


const goToPlansPricing = (planKey) => {
  navigate("/PlansPricing", { state: { planKey } });
};




// Referral handling
useEffect(() => {
  const qs = new URLSearchParams(window.location.search);
  const planKey = (qs.get("plan") || "").toUpperCase();
  const code = (qs.get("code") || "").toUpperCase();

  if (!planKey || !code) return;

  // validate preview (works for guests)
  axios.post(`${BASE}/referral_preview`, { planKey, code })
    .then(async (res) => {
      if (res.data?.status !== "success") return;

      const raw = (res.data.code || "").toUpperCase().replace(/-/g,"");
      const discount = Number(res.data.discountAmount || 0);

      // Save for guest view
      sessionStorage.setItem(REF_PLAN_KEY, planKey);
      sessionStorage.setItem(REF_CODE_KEY, raw);
      sessionStorage.setItem(REF_DISC_KEY, String(discount));

      // If logged in, persist to USER node
      const user = JSON.parse(localStorage.getItem("user") || "null");
      if (user?.email) {
        try {
          await axios.post(`${BASE}/set_referral_plan`, { email: user.email, planKey, code: raw });
        } catch {}
      }
    })
    .catch(() => {});
}, []);





// helper inside Choose component
const getReferralContext = () => {
  const planKey = sessionStorage.getItem(REF_PLAN_KEY);
  const disc = parseFloat(sessionStorage.getItem(REF_DISC_KEY) || "0");
  return { planKey, disc: isNaN(disc) ? 0 : disc };
};

const formatEur = (n) => new Intl.NumberFormat(lang || undefined, { style: "currency", currency: "EUR" }).format(n);

// when rendering BASIC price:
const baseBasic = 8.99;
const { planKey: refPlan, disc: refDisc } = getReferralContext();
const basicShown = refPlan === "BASIC" ? Math.max(0, baseBasic - refDisc) : baseBasic;








// tiny helpers for caching
const cacheKey = (lang) => `choose_translated_tours_${lang}`;
const loadCache = (lang) => {
  try { return JSON.parse(sessionStorage.getItem(cacheKey(lang)) || "null"); } catch { return null; }
};
const saveCache = (lang, data) => {
  try { sessionStorage.setItem(cacheKey(lang), JSON.stringify(data)); } catch {}
};

useEffect(() => {
  let cancelled = false;
  (async () => {
    setLoadingTours(true);
    try {
      // 1) fetch once
      const res = await axios.get(`${BASE}/getAllToursByName`);
      const parsed = JSON.parse(res.data) || [];

      // 2) render raw immediately (no translate yet)
      if (!cancelled) setTours(parsed.map(t => ({
        ...t,
        likes: Number(t.likes ?? 0),
        totalComments: Number(t.totalComments ?? 0),
        views: Number(t.views ?? 526),
        price: Number(t.price),
      })));

      setLoadingTours(false);

      // 3) see if we already have translated cache for this lang
      const cached = loadCache(lang);
      if (cached && Array.isArray(cached) && !cancelled) {
        setTours(cached);
        return;
      }

      // 4) translate in background, then update
      setTranslating(true);
      const translated = await Promise.all(parsed.map(async (tour) => ({
        ...tour,
        name: await translateText(tour.name),
        subheading: await translateText(tour.subheading),
        description: await translateText(tour.description),
        Region: await translateText(tour.Region),
        PrimaryCategory: await translateText(tour.PrimaryCategory),
        likes: Number(tour.likes ?? 0),
        totalComments: Number(tour.totalComments ?? 0),
        views: Number(tour.views ?? 526),
        price: Number(tour.price),
      })));


      if (!cancelled) {
          setTours(parsed.map(t => ({
            ...t,
            likes: Number(t.likes ?? 0),
            totalComments: Number(t.totalComments ?? 0),
            views: Number(t.views ?? 526),
            price: Number(t.price),
          })));
          setLoadingTours(false);
          setInterestsHydrated(false);
      }
    } catch (e) {
      console.error("Error fetching tours:", e);
      setLoadingTours(false);
      setTranslating(false);
    } finally {
      setTranslating(false);
    }
  })();
  return () => { cancelled = true; };
}, [lang, translateText]);





// Next month
useEffect(() => {
  let cancelled = false;

  const loadNextMonthTours = async () => {
    try {
      const res = await axios.get(`${BASE}/getNextMonthTours`);
      // backend may return JSON string or array; normalize:
      const raw = Array.isArray(res.data) ? res.data : JSON.parse(res.data || "[]");

      // Map fields coming from Neo4j "properties" (your example payload)
      const normalized = raw.map(row => {
        const p = row.properties || row.n?.properties || {};
        return {
          id: row.id || row.identity || row.elementId || row.n?.elementId || row.n?.identity,
          Image: p.Image || p.image || p.Cover || p.cover || "",

          // IT sources → will be translated below
          name_it: p.titelo_it || p.titolo_it || p.title_it || "Tour",
          subheading_it: p.subheading_it || "",
          desc_it: p.desc_it || "",

          Region: p.Region || "",
          PrimaryCategory: p.PrimaryCategory || "",
          price: Number(p.FullPrice ?? p.price ?? 0),
        };
      });

      const translated = await Promise.all(
        normalized.map(async t => ({
          ...t,
          name: await translateText(t.name_it),
          subheading: await translateText(t.subheading_it),
          description: await translateText(t.desc_it),
          Region: await translateText(t.Region),
          PrimaryCategory: await translateText(t.PrimaryCategory),
        }))
      );

      if (!cancelled) {
        setNextTours(translated);
        setNextMonthIds(new Set(translated.map(t => String(t.id))));
      }
    } catch (e) {
      console.error("Error fetching next-month tours:", e);
    }
  };

  loadNextMonthTours();
  return () => { cancelled = true; };
}, [lang, translateText]);



// -----------------------------------
// Fuori Rotta card
// -----------------------------------
useEffect(() => {
  const fetchFuori = async () => {
    setFuoriLoading(true);
    setFuoriError(null);
    try {
      const url = `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getFuorirotta?nodeID=127981&lang=${lang}`;
      const res = await fetch(url);
      const contentType = res.headers.get("content-type") || "";

      let data;
      if (contentType.includes("application/json")) {
        data = await res.json();
      } else {
        const txt = await res.text();
        data = txt === "0" || txt === 0 ? "0" : JSON.parse(txt);
      }

      const mediaBase = "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/";
      const fallbackImg = mediaBase + "Teche/placeholder.jpg";

      if (data === "0" || data === 0 || !data?.tour) {
        setFuoriCard({
          title: translatedText.fuoriRottaTitle,
          subheading: translatedText.fuoriRottaSubheading,
          imgg: fallbackImg,
          isFallback: true,
        });
        return;
      }

      const t = data.tour || {};
      const imgPath = t.Image || t.copertina || t.Copertina || null;
      const imgg = imgPath ? mediaBase + imgPath : fallbackImg;

      setFuoriCard({
        title: t.titolo_it || t.titelo_it || t.Name_it || translatedText.fuoriRottaTitle,
        subheading: t.subheading_it || t.Subheading_it || translatedText.fuoriRottaSubheading,
        imgg,
      });
    } catch (e) {
      setFuoriError(e?.message || "Errore sconosciuto");
      setFuoriCard({
        title: translatedText.fuoriRottaTitle,
        subheading: translatedText.fuoriRottaSubheading,
        imgg: "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Teche/placeholder.jpg",
        isFallback: true,
      });
    } finally {
      setFuoriLoading(false);
    }
  };

  fetchFuori();
}, [lang, translatedText]);





useEffect(() => {
  if (interestsHydrated || tours.length === 0) return;

  let cancelled = false;
  (async () => {
    try {
      const need = tours.filter(t => !Array.isArray(t.Interessi) || t.Interessi.length === 0);
      if (need.length === 0) {
        if (!cancelled) setInterestsHydrated(true);
        return;
      }

      const lookups = await Promise.all(
        need.map(async (t) => {
          try {
            const r = await fetch(`${BASE}/getTecheTourByIDNew?nodeID=${t.id}&lang=it`);
            const j = await r.json();
            const Interessi = Array.isArray(j?.tour?.Interessi) ? j.tour.Interessi : [];
            return [t.id, Interessi];
          } catch {
            return [t.id, []];
          }
        })
      );
      if (cancelled) return;

      const map = new Map(lookups);
      setTours(prev => prev.map(t => map.has(t.id) ? { ...t, Interessi: map.get(t.id) } : t));
      setInterestsHydrated(true);
    } catch {
      if (!cancelled) setInterestsHydrated(true);
    }
  })();

  return () => { cancelled = true; };
}, [tours, interestsHydrated]);






/*  useEffect(() => {
    const fetchTours = async () => {
      try {
        const response = await axios.get("https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getAllToursByName");
        if (response.data) {
          const parsedData = JSON.parse(response.data);
  
          const translatedTours = await Promise.all(parsedData.map(async (tour) => ({
            ...tour,
            name: await translateText(tour.name),
            subheading: await translateText(tour.subheading),
            description: await translateText(tour.description),
            Region: await translateText(tour.Region),
            PrimaryCategory: await translateText(tour.PrimaryCategory),
            likes: Number(tour.likes ?? 0),
            totalComments: Number(tour.totalComments ?? 0),
            views: Number(tour.views ?? 526),
            price: Number(tour.price),
          })));

          const toursWithInterests = await Promise.all(
            translatedTours.map(async (t) => {
              try {
                const r = await fetch(`${BASE}/getTecheTourByIDNew?nodeID=${t.id}&lang=it`);
                const j = await r.json();
                const Interessi = Array.isArray(j?.tour?.Interessi) ? j.tour.Interessi : [];
                return { ...t, Interessi };
              } catch {
                return { ...t, Interessi: [] };
              }
            })
          );

          setTours(toursWithInterests);
//          setTours(translatedTours);
//          console.log("Tours loaded:", toursWithInterests);
        }
      } catch (error) {
        console.error("Error fetching tours:", error);
      }
    };
  
    fetchTours();
  }, [translateText]); // re-run if language changes
*/
  



/*
  useEffect(() => {
    const fetchNextMonthTours = async () => {
      try {
        const res = await axios.get(`${BASE}/getNextMonthTours`);
        const parsed = JSON.parse(res.data);
        const translated = await Promise.all(parsed.map(async (tour) => ({
          ...tour,
          name: await translateText(tour.properties.titelo_it || "Tour"),
          subheading: await translateText(tour.properties.subheading_it || ""),
          description: await translateText(tour.properties.desc_it || ""),
          Region: await translateText(tour.properties.Region || ""),
          PrimaryCategory: await translateText(tour.properties.PrimaryCategory || ""),
          price: Number(tour.properties.FullPrice ?? 0)
        })));
        setTours(translated);
        console.log("👉 Next month tours:", translated);
      } catch (err) {
        console.error("Error fetching next month tours:", err);
      }
    };

    fetchNextMonthTours();
  }, [lang, translateText]);
*/



/*  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${BASE}/getNextMonthTours`);
        const rows = await res.json();
        setNextMonthIds(new Set((rows || []).map(r => String(r.id))));
      } catch {}
    })();
  }, []);
*/

useEffect(() => {
  let cancelled = false;
  const run = async () => {
    try {
      const { data } = await axios.get(`${BASE}/getPackageTours`, { params: { key: "RADICI" } });
      if (cancelled) return;

      if (data?.status === "success") {
        // tours
        const hydrated = await Promise.all(
          (data.tours || []).map(async (tour) => ({
            ...tour,
            name: await translateText(tour.name),
            subheading: await translateText(tour.subheading),
            description: await translateText(tour.description),
            Region: await translateText(tour.Region),
            PrimaryCategory: await translateText(tour.PrimaryCategory),
            likes: Number(tour.likes ?? 0),
            totalComments: Number(tour.totalComments ?? 0),
            views: Number(tour.views ?? 526),
          }))
        );
        setPackageTours(hydrated);

        // price + currency from backend/Stripe
        const amt = Number(data.package?.amount_eur ?? NaN);
        if (!Number.isNaN(amt)) setPackagePrice(amt);
        if (data.package?.currency) setPackageCurrency(String(data.package.currency).toUpperCase());
      }
    } catch (e) {
      // optional: toast/log
    }
  };
  run();
  return () => { cancelled = true; };
}, [translateText]);




const handleLike = async (e, tourId) => {
  e.stopPropagation();
  const user = JSON.parse(localStorage.getItem("user"));
  if (!user || !user.email) {
    setShowSignupModal(true);
    return;
  }

  try {
    const response = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/addRemoveLikeToTour`, {
      params: { tourID: tourId, email: user.email }
    });

    const result = response.data;

    if (result === 1 || result === 0) {
      setTours(prev =>
        prev.map(t => {
          if (t.id === tourId) {
            const updatedLikes = t.likes + (result === 1 ? 1 : -1);
            return { ...t, likes: Math.max(0, updatedLikes) };
          }
          return t;
        })
      );
    }

  } catch (error) {
    console.error("Errore durante il toggle like:", error);
  }
};




  

  






  useEffect(() => {
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setShowSignupModal(false);
    }
  };

  if (showSignupModal) {
    window.addEventListener("keydown", handleKeyDown);
  }

  return () => {
    window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showSignupModal]);


  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setPlanPreview({ open: false, planKey: null });
    };
    if (planPreview.open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [planPreview.open]);




  const visibleTours = tours.filter((t) => {
    if (!selectedInteressi.length) return true;
    const ints = Array.isArray(t.Interessi) ? t.Interessi : [];
    return ints.some((i) => selectedInteressi.includes(Number(i)));
  });










  const SkeletonCard = () => (
  <div className="bg-white rounded-xl shadow animate-pulse flex flex-col h-full">
    <div className="h-48 w-full bg-gray-200 rounded-t-xl" />
    <div className="p-4 space-y-3">
      <div className="h-6 bg-gray-200 rounded w-3/4" />
      <div className="h-5 bg-gray-200 rounded w-5/6" />
      <div className="flex items-center justify-between mt-4">
        <span className="h-6 w-24 bg-gray-200 rounded" />
        <span className="h-6 w-28 bg-gray-200 rounded" />
      </div>
      <div className="mt-4 h-9 bg-gray-200 rounded-full" />
    </div>
  </div>
);










// Helper to put FREE tours first, then lower price, then name (localized)
const sortTours = (a, b) => {
  const pa = Number(a.price ?? Infinity);
  const pb = Number(b.price ?? Infinity);

  const aFree = pa === 0;
  const bFree = pb === 0;
  if (aFree && !bFree) return -1;
  if (!aFree && bFree) return 1;

  // then by numeric price ascending
  if (pa !== pb) return pa - pb;

  // finally by name, using current lang collator for stability
  return String(a.name || "").localeCompare(String(b.name || ""), lang || undefined, { sensitivity: "base" });
};

const sortedVisibleTours = React.useMemo(
  () => [...visibleTours].sort(sortTours),
  [visibleTours, lang]
);


const noResults = !loadingTours && !translating && sortedVisibleTours.length === 0;





/*

const FuoriRottaMiniCard = ({ pricePill }) => {
  if (!fuoriCard) return null;

  return (
    <div
      className="mt-3 border rounded-xl overflow-hidden hover:shadow-md transition cursor-pointer"
      onClick={(e) => {
        e.stopPropagation();
        navigate("/fuoriPreview/127981");
      }}
    >
      <div className="relative mx-auto w-3/4 sm:w-2/3 pt-[46.25%] rounded-lg overflow-hidden">
        <img
          src={fuoriCard.imgg}
          alt={fuoriCard.title}
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        {pricePill && (
          <div className="absolute top-2 right-2 bg-white/80 text-black text-xs sm:text-sm md:text-base
                          font-semibold px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-md shadow">
            🏷️ {pricePill}
          </div>
        )}
      </div>

      <div className="p-3">
        <h4 className="text-sm sm:text-base font-semibold text-black text-center">
          {fuoriCard.title}
        </h4>
        {fuoriCard.subheading && (
          <p className="text-xs sm:text-sm text-neutral-600 text-center">{fuoriCard.subheading}</p>
        )}
      </div>
    </div>
  );
};
*/





{!loadingTours && translating && (
  <div className="text-center text-sm text-neutral-500 mb-4" role="status">
    {translatedText.text199.replace("$lang", lang)}
  </div>
)}

  return (
  <>
  {/* Hero Section */}
  <div className="bg-[#324B8E] w-full min-h-[260px] sm:min-h-[320px] md:min-h-[380px] flex flex-col justify-center px-4 sm:px-8 md:px-16 py-8 sm:py-10 text-white">
    <h1 className="mt-2 text-3xl sm:text-4xl md:text-6xl font-bold leading-tight tracking-tight flex items-center gap-3">
      <img
        src="/LOGO_TECHE_symol.png"
        alt=""
        aria-hidden="true"
        className="h-[1.2em] w-auto align-middle"
        style={{ clipPath: "inset(0 0 40% 0)" }}  // To show upper half only
      />
      {translatedText.text1 || "TecheTour"}
    </h1>

        <h2 className="mt-1 text-xl sm:text-2xl md:text-4xl font-medium leading-tight tracking-tight flex items-center gap-2">
          {translatedText.textRadici || "Radici in Viaggio"}
        </h2>

    <p className="mt-3 mb-3 max-w-2xl text-base/7 sm:text-lg/7 md:text-xl/8 text-white/90">
      {translatedText.text2 || "Sfoglia, scegli, vivi: scopri tutti i nostri tour STREAM-IMMERSION"}
    </p>
       
    <p className="mt-4 max-w-3xl text-sm/7 sm:text-base/7 md:text-lg/8 text-white/85">
      {translatedText.header1}
    </p>
    <p className="mt-1 max-w-3xl text-sm/7 sm:text-base/7 md:text-lg/8 text-white/85">
      {translatedText.header2}
    </p>

      
    </div>


    <div className="min-h-screen bg-gray-100 pt-24 sm:pt-28 md:pt-32 pb-10 px-4 sm:px-6">
      <div className="w-full flex justify-center -mt-10 px-3">
        <div className="mx-auto max-w-7xl">
          <div
              className="inline-flex bg-white shadow rounded-full p-1 sm:p-2 mb-12 overflow-x-auto max-w-full gap-1
                        scrollbar-thin scrollbar-thumb-neutral-300 scrollbar-track-transparent
                        snap-x snap-mandatory"
              role="tablist"
              aria-label="Seleziona categoria"
            >
            <button
              className={`${tabBtn("singolo")} text-sm sm:text-base md:text-2xl px-4 sm:px-6 py-2 sm:py-3 snap-start`}
              onClick={() => setMode("singolo")}
              role="tab"
              aria-selected={mode === "singolo"}
            >
              {translatedText.tabSingle}
            </button>
            <button
              className={`${tabBtn("pacchetto")} text-sm sm:text-base md:text-2xl px-4 sm:px-6 py-2 sm:py-3 snap-start`}
              onClick={() => setMode("pacchetto")}
              role="tab"
              aria-selected={mode === "pacchetto"}
            >
              {translatedText.tabBundle}
            </button>
            <button
              className={`${tabBtn("abbonamento")} text-sm sm:text-base md:text-2xl px-4 sm:px-6 py-2 sm:py-3 snap-start`}
              onClick={() => setMode("abbonamento")}
              role="tab"
              aria-selected={mode === "abbonamento"}
            >
              {translatedText.tabSub}
            </button>
          </div>
        </div>
      </div>




      {mode === "singolo" && (
        <>
{/* Interessi Filter */}
<div className="max-w-7xl mx-auto mt-2 mb-6 px-2">
  <div className="flex flex-nowrap sm:flex-wrap items-center justify-start sm:justify-center gap-2 overflow-x-auto scrollbar-thin scrollbar-thumb-neutral-300 scrollbar-track-transparent py-1">
    {Object.entries(translatedInteressi).map(([id, label]) => {
      const active = selectedInteressi.includes(Number(id));
      return (
        <button
          key={id}
          onClick={() => {
            setSelectedInteressi((prev) =>
              prev.includes(Number(id))
                ? prev.filter((x) => x !== Number(id))
                : [...prev, Number(id)]
            );
          }}
          className={
            "px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-full text-xs sm:text-sm border transition " +
            (active
              ? "bg-[#324B8E] text-white border-[#324B8E]"
              : "text-[#324B8E] border-[#324B8E] hover:bg-[#324B8E]/10")
          }
        >
          {label}
        </button>
      );
    })}
    {selectedInteressi.length > 0 && (
      <button
        onClick={() => setSelectedInteressi([])}
        className="ml-2 px-3 py-1.5 rounded-full text-sm border border-neutral-300 hover:bg-neutral-50"
      >
        ✕ {resetFilterLabel}
      </button>
    )}
  </div>
</div>






{noResults ? (
  <div
    className="max-w-7xl mx-auto mt-10 mb-16 px-4 py-14 bg-white rounded-2xl shadow text-center"
    role="status"
    aria-live="polite"
  >
    <div className="mx-auto mb-4 w-14 h-14 rounded-full bg-[#324B8E]/10 flex items-center justify-center">
      <span className="text-2xl">🔎</span>
    </div>
    <h3 className="text-xl sm:text-2xl font-semibold text-neutral-900">
      {translatedText.textNoResultsTitle}
    </h3>
    <p className="mt-2 text-sm sm:text-base text-neutral-600">
      {translatedText.textNoResultsBody}
    </p>
  </div>
) : (
<div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto" aria-busy={loadingTours || translating}>
  {loadingTours
    ? Array.from({ length: 6 }).map((_, i) => <SkeletonCard key={`sk-${i}`} />)
    : sortedVisibleTours.map((tour, idx) => {
      const isLast = idx === sortedVisibleTours.length - 1;
      const remainder = sortedVisibleTours.length % 3;
      const centerSolo = remainder === 1 && isLast; // Show only one item on last row

      return (
          <div
            key={tour.id}
            className={
              "bg-white rounded-xl shadow hover:shadow-lg transition-all duration-200 cursor-pointer flex flex-col h-full " +
              (centerSolo ? " md:col-start-2" : "")
            }
            onClick={() => navigate(`/tourPreview/${tour.id}`)}
          >
            <div className="relative overflow-hidden rounded-t-xl">
              <img
                src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${tour.Image}`}
                alt={tour.name}
                className="h-48 w-full object-cover transform transition-transform duration-300 hover:scale-110"
              />
              <div className="absolute top-2 right-2 bg-white/80 text-black text-xl font-semibold px-2 py-1 rounded-md shadow">
                🏷️ {formatPrice(tour.price)}
              </div>
            </div>
            <div className="flex flex-col justify-between flex-grow p-4">
            

            <h2 className="text-lg font-semibold text-black text-center h-[60px] flex items-center justify-center text-ellipsis text-wrap">{tour.name} </h2>
            <h2 className="text-lg font-medium text-black text-center h-[60px] flex items-center justify-center text-ellipsis text-wrap">{tour.subheading} </h2>
       {/*     <p className="text-sm text-black mt-2 text-justify leading-relaxed max-w-prose mx-auto">{tour.description}</p>           */}
       {/*       <p className="text-sm font-semibold text-black mt-3">{translatedText.text4}: {tour.duration} {Number(tour.duration) === 1 ? translatedText.durationDay : translatedText.durationDay2}</p>      */}

              {/* Icon Row with interactivity */}
              <div className="mb-6 flex items-center justify-between mt-4 text-black text-sm select-none">
                {/* Likes */}
                <div
                  className="flex items-center space-x-1 hover:text-red-600 cursor-pointer transition"
                  title={translatedText.tooltipLikes}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleLike(e, tour.id)
                  }}


                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 015.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" />
                  </svg>
                  <span>{typeof tour.likes === "number" ? tour.likes : 0}</span>
                </div>

                {/* Comments */}
                <div
                  className="flex items-center space-x-1 hover:text-blue-500 cursor-pointer transition"
                  title={translatedText.tooltipComments}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M18 10c0-3.866-3.582-7-8-7S2 6.134 2 10c0 1.87 1.163 3.535 3 4.584V18l3.5-2H10c4.418 0 8-3.134 8-7z" />
                  </svg>
                  <span>{Number(tour.totalComments) || 0}</span>
                </div>
                

                {/* Views */}
                <div
                  className="flex items-center space-x-1 hover:text-green-600 cursor-pointer transition"
                  title={translatedText.tooltipViews}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <span className="text-lg">👁️</span>
                  <span>{tour.views || 526}</span>
                </div>
              </div> 




              <div className="mt-3 flex items-center justify-between">
                <span className="inline-block text-black text-sm px-4 py-1 rounded-md">
                  {tour.Region}
                </span>

                <span className="inline-block text-[#324B8E] border border-[#324B8E] text-sm px-4 py-1 rounded-md">
                  {tour.PrimaryCategory}
                </span>
              </div>















              <div className="mt-4 text-center">
                <button
                  className="bg-[#324B8E] text-white px-4 py-2 rounded-full text-sm"
                  onClick={() => navigate(`/tourPreview/${tour.id}`)}
                >
                  {translatedText.discoverTour}
                </button>
              </div>

            </div>
          </div>
          );
  })}


        

        {/* end of visible tours */}
      </div>
)}
      </>
    )}





    {/* --- Next Month's Tours section --- */}
{mode === "singolo" && nextTours.length > 0 && (
  <>
    <div className="max-w-7xl mx-auto mt-20 mb-20 px-2">
      <h3 className="text-center text-3xl md:text-4xl font-bold text-neutral-900">
        {translatedText.nextMonthTitle}
      </h3>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto">
      {nextTours.map((tour, idx) => {
          const isLast = idx === nextTours.length - 1;
          const remainder = nextTours.length % 3;
          const centerSolo = remainder === 1 && isLast; // Show last card at the center of last row

        return (
        <div
          key={`next-${tour.id}`}
          className={
            "bg-white rounded-xl shadow hover:shadow-lg transition-all duration-200 cursor-pointer flex flex-col h-full" +
            (centerSolo ? " md:col-start-2" : "")
          }
          onClick={() => navigate(`/tourPreview/${tour.id}`)}
        >
          <div className="relative overflow-hidden rounded-t-xl">
            <img
              src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${tour.Image}`}
              alt={tour.name}
              className="h-40 sm:h-48 w-full object-cover transform transition-transform duration-300 hover:scale-110"
            />

            {/* price pill */}
            <div className="absolute top-2 right-2 bg-white/80 text-black text-xl font-semibold px-2 py-1 rounded-md shadow">
              🏷️ {formatPrice(tour.price)}
            </div>

            {/* little ribbon to hint Coming soon */}
            <div className="absolute top-2 left-2 bg-white/80 text-black text-xl font-semibold px-2 py-1 rounded-md shadow">
              {translatedText.textNextmonth}
            </div>
          </div>

          <div className="flex flex-col justify-between flex-grow p-4">
            <h2 className="text-lg font-semibold text-black text-center h-[60px] flex items-center justify-center text-ellipsis text-wrap">
              {tour.name}
            </h2>
            <h2 className="text-lg font-medium text-black text-center h-[60px] flex items-center justify-center text-ellipsis text-wrap">
              {tour.subheading}
            </h2>

            <div className="mt-3 flex items-center justify-between">
              <span className="inline-block text-black text-sm px-4 py-1 rounded-md">
                {tour.Region}
              </span>
              <span className="inline-block text-[#324B8E] border border-[#324B8E] text-sm px-4 py-1 rounded-md">
                {tour.PrimaryCategory}
              </span>
            </div>

            <div className="mt-4 text-center">
              <button
                className="bg-[#324B8E] text-white px-4 py-2 rounded-full text-sm"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/tourPreview/${tour.id}`);
                }}
              >
                {translatedText.discoverTour}
              </button>
            </div>
          </div>
        </div>
        );
      })}
    </div>
  </>
)}









    {mode === "pacchetto" && (
  <div className="w-full max-w-7xl mx-auto">
    {!bundleOpen ? (
      // ----------------------------
      // CLOSED: show single bundle card
      // ----------------------------
      <div className="max-w-xl mx-auto">
        <div
          className="bg-white rounded-2xl shadow hover:shadow-lg transition cursor-pointer overflow-hidden"
          onClick={() => setBundleOpen(true)}
          role="button"
          aria-label={translatedText.textApripacchetto}
        >
          <div className="relative h-56 w-full overflow-hidden">
            <img
              //src={`${BASE}/media/Teche/Pacchetto.jpg`}
              src= "../images/ChoosePage/Pacchetto.jpg"
              alt="Pacchetto Radici Italiane"
              className="h-full w-full object-cover"
            />
            <div className="absolute top-2 left-2 bg-white/90 text-black text-sm px-3 py-1 rounded-md shadow">
              {packageTours.length} {translatedText.toursIncluded}
            </div>

                <div className="absolute top-2 right-2 bg-white/80 text-black text-xl font-semibold px-2 py-1 rounded-md shadow">
                  🏷️ {packagePrice != null ? formatMoney(packagePrice, packageCurrency) : "…"}    {/* Package price */}
                </div>
                {packagePrice != null && originalTotal > 0 && (
                  <div className="mt-1 text-center text-sm text-neutral-600">
                    <span className="line-through mr-1">{formatMoney(originalTotal, packageCurrency)}</span>
                    <span className="font-medium">→ {formatMoney(packagePrice, packageCurrency)}</span>
                  </div>
                )}

          </div>

          <div className="p-6">
            <h3 className="text-2xl text-center font-semibold text-neutral-900">
              {translatedText.bundleName}
            </h3>
            <p className="text-black text-center mt-1">
              {translatedText.text6.replace("€9,99", formatMoney(packagePrice ?? 9.99, packageCurrency))}
            </p>

            <div className="mt-4 flex justify-center items-center gap-3 flex-wrap">
              {packageTours.slice(0, 3).map((t) => (
                <img
                  key={t.id}
                  className="h-10 w-10 rounded-md object-cover"
                  src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${t.Image}`}
                  alt={t.name}
                  title={t.name}
                />
              ))}
            </div>

            <button
              className="mt-5 w-full inline-flex items-center justify-center rounded-full px-4 py-3 text-white bg-[#324B8E] hover:opacity-95"
              onClick={async (e) => {
                e.stopPropagation();
                const currentUser = JSON.parse(localStorage.getItem("user") || "null");
                if (!currentUser?.email) {
                  sessionStorage.setItem("selected_package", "RADICI");
                  navigate("/CompleteRegistration", { state: { packageKey: "RADICI" } });
                  return;
                }
                try {
                  const { data } = await axios.post(`${BASE}/saveToCart`, {
                    email: currentUser.email,
                    packageKey: "RADICI",
                  });
                  if (data.status === "success") {
                    window.dispatchEvent(new Event("showCartPopup"));
                    navigate("/carrello");
                  } else {
                    alert(data.message || "Non riesco ad aggiungere il pacchetto.");
                  }
                } catch (err) {
                  alert(err?.response?.data?.message || err.message);
                }
              }}
            >
              {translatedText.bundleCartBtn}
            </button>

          </div>
        </div>
      </div>
    ) : (
      // ----------------------------
      // OPEN: show the 3 tour cards
      // ----------------------------
      <>
        <div className="flex items-center justify-between mb-4 px-1">
          <button
            onClick={() => setBundleOpen(false)}
            className="text-sm rounded-full px-4 py-2 border border-neutral-300 hover:bg-neutral-50"
          >
            {translatedText.backToBundle}
          </button>
          <div className="text-sm text-neutral-600">
            {packageTours.length} {translatedText.toursIncluded}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {packageTours.map((tour) => (
            <div
              key={tour.id}
              className="bg-white rounded-xl shadow hover:shadow-lg transition-all duration-200 cursor-pointer flex flex-col h-full"
              onClick={() => navigate(`/tourPreview/${tour.id}`)}
            >
              <div className="relative overflow-hidden rounded-t-xl">
                <img
                  src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${tour.Image}`}
                  alt={tour.name}
                  className="h-48 w-full object-cover transform transition-transform duration-300 hover:scale-110"
                />
              </div>

              <div className="flex flex-col justify-between flex-grow p-4">
                <h2 className="text-lg font-semibold text-black text-center h-[60px] flex items-center justify-center">
                  {tour.name}
                </h2>
                <h2 className="text-lg font-medium text-black text-center h-[60px] flex items-center justify-center">
                  {tour.subheading}
                </h2>

                <div className="mt-3 flex items-center justify-between">
                  <span className="inline-block text-black text-sm px-4 py-1 rounded-md">
                    {tour.Region}
                  </span>
                  <span className="inline-block text-[#324B8E] border border-[#324B8E] text-sm px-4 py-1 rounded-md">
                    {tour.PrimaryCategory}
                  </span>
                </div>

                <div className="mt-4 text-center">
                  <button
                    className="bg-[#324B8E] text-white px-4 py-2 rounded-full text-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/tourPreview/${tour.id}`);
                    }}
                  >
                    {translatedText.discoverTour}
                  </button>
                </div>
              </div>
            </div>
          ))}

        
        </div>
        <div>



<button
  className="mt-5 w-full inline-flex items-center justify-center rounded-full px-4 py-3 text-white bg-[#324B8E] hover:opacity-95"
  onClick={async (e) => {
    e.stopPropagation();
    const currentUser = JSON.parse(localStorage.getItem("user") || "null");
    if (!currentUser?.email) {
      sessionStorage.setItem("selected_package", "RADICI");
      navigate("/CompleteRegistration", { state: { packageKey: "RADICI" } });
      return;
    }
    try {
      const { data } = await axios.post(`${BASE}/saveToCart`, {
        email: currentUser.email,
        packageKey: "RADICI",
      });
      if (data.status === "success") {
        window.dispatchEvent(new Event("showCartPopup"));
        navigate("/carrello");
      } else {
        alert(data.message || "Non riesco ad aggiungere il pacchetto.");
      }
    } catch (err) {
      alert(err?.response?.data?.message || err.message);
    }
  }}
>
  {translatedText.bundleCartBtn}
</button>
</div>


      </>
    )}
  </div>
)}












{/*
{mode === "abbonamento" && (
  <div className="w-full max-w-7xl mx-auto px-6 pt-10">
    <h1 className="text-3xl md:text-4xl font-bold text-neutral-900">
      {translatedText.text8}
    </h1>
    
  </div>

)}
*/}

{mode === "abbonamento" && (
  <>
    {/*   Use the below div and delete the other when setting two plans   
    <div className="grid gap-4 sm:gap-6 md:grid-cols-2 max-w-7xl mx-auto mt-6 sm:mt-8 px-3 sm:px-6 items-stretch"> */}
    <div className="grid gap-4 sm:gap-6 grid-cols-1 max-w-7xl mx-auto mt-6 sm:mt-8 px-3 sm:px-6 place-items-center">
      {[
        {
          key: "BASIC",
          name: translatedText.planNameBasic,
          price: translatedText.priceBasic,
          label: translatedText.basicAdLabel,
          gradient: "from-indigo-600 to-indigo-400",
          features: [
            { Icon: CalendarDays, text: translatedText.basicFeature1 },
            //{ Icon: Percent, text: "Puoi fruire di 2 tour precedenti con sconto del 40%" },
            { Icon: Users, text: "Estensioni disponibili: abbonamento fino a 3 amici/familiari al costo di €4,99 ciascuno per il primo mese" },
            { Icon: Sparkles, text: translatedText.basicFeature2 },
            { Icon: ShieldX, text: translatedText.plansFooter3 },
          ],
        },
        {
          key: "PLUS",
          name: translatedText.planNamePlus,
          price: translatedText.pricePlus,
          label: translatedText.plusAdLabel,
          gradient: "from-sky-600 to-rose-500",
          features: [
            { Icon: CalendarDays, text: translatedText.plusFeature1 },
            //{ Icon: Percent, text: "Puoi fruire di 3 tour precedenti con sconto del 60%" },
            { Icon: Users, text: translatedText.textxxxx },
            { Icon: Sparkles, text: translatedText.plusFeature2 },
            { Icon: ShieldX, text: translatedText.plansFooter3 },
            { Icon: Monitor, text: translatedText.plusFeatureMetaverse },
          ],
          recommendedPill: true,
        },
      ].map((p) => (
        <div
          key={p.key}
      
          // hide BASIC from users
          className={
            "relative bg-white rounded-2xl border border-neutral-200 overflow-hidden shadow hover:shadow-lg transition h-full" +
            (p.key === "BASIC" ? " hidden" : "")
          }
          role="button"
          tabIndex={0}
          onClick={() => setPlanPreview({ open: true, planKey: p.key })}
          onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setPlanPreview({ open: true, planKey: p.key })}
          aria-label={`Apri anteprima piano ${p.name}`}
        >

          {/* top gradient strip */}
          <div className={`h-2 bg-gradient-to-r ${p.gradient}`} />

          {/* tiny pill on PLUS, top-right */}
          {p.recommendedPill && (
            <div className="absolute right-3 top-3 text-xs bg-neutral-900 text-white px-2 py-1 rounded-full">
              {translatedText.recommended}
            </div>
          )}

          <div className="p-6 flex flex-col gap-4">
            <div className="space-y-1 min-h-[48px] md:min-h-[56px]">
              <div className="text-base sm:text-lg text-black">{p.label}</div>
              <h3 className="text-xl sm:text-2xl font-semibold text-neutral-900">{p.name}</h3>
            </div>

            {(() => {
              // base plan price
              const base = p.key === "BASIC" ? 8.99 : 19.99;

              // referral from session
              const { planKey: refPlan, disc: refDisc } = getReferralContext();
              const shown = refPlan === p.key ? Math.max(0, base - refDisc) : base;

              return (
                <div className="text-2xl sm:text-3xl font-bold min-h-[36px] md:min-h-[40px]">
                  {formatEur(shown)}
                  {/* tiny pill when referral applied */}
                  {refPlan === p.key && refDisc > 0 && (
                    <span className="ml-2 align-middle inline-flex items-center rounded-full bg-emerald-50 text-emerald-700 text-xs px-2 py-[2px] border border-emerald-200">
                      −{formatEur(refDisc)}
                    </span>
                  )}
                </div>
              );
            })()}

{(() => {
  const { planKey: refPlan, disc: refDisc } = getReferralContext();
  if (refPlan === p.key && refDisc > 0) {
    return (
      <div className="text-xs text-emerald-700 mt-1">
        Referral applicato • −{formatEur(refDisc)}
      </div>
    );
  }
  return null;
})()}


            {/* features with icons */}
            <ul className="text-sm text-neutral-700 space-y-2 min-h-[56px] md:min-h-[72px]">
              {p.features.map(({ Icon, text }, i) => (
                <li key={i} className="flex items-start gap-2">
                  <Icon className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <span className="line-clamp-2">{text}</span>
                </li>
              ))}
            </ul>






            {/* Acquista” */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                setPlanPreview({ open: true, planKey: p.key }); // <-- open tiny window
              }}
              className="mt-2 w-full inline-flex items-center justify-center rounded-md px-4 py-3 text-white bg-[#324B8E] hover:opacity-95"
            >
              {translatedText.bundleCartBtn}
            </button>
          </div>
        </div>
      ))}
    </div>


    {/* Footer under carts 
    <div className="max-w-7xl mx-auto px-6 mt-6">
      <p className="text-sm text-neutral-700 font-medium">
        {translatedText.plansFooter1}{" "}
        <Link to="/PlansPricing" className="text-blue-600 no-underline hover:no-underline">
          {translatedText.basictext}
        </Link>{" "}
        {translatedText.conjunctionAnd}{" "}
        <Link to="/PlansPricing" className="text-blue-600 no-underline hover:no-underline">
          {translatedText.plustext}
        </Link>.
      </p>
      

      <p className="text-sm text-neutral-600 mt-3">
        {translatedText.plansFooter2}
      </p>
      
    </div>*/}
  </>
)}














{/* Plan Preview Tiny Window (Modal) */}
{planPreview.open && (
  <div
    className="fixed inset-0 z-[100] flex items-center justify-center p-4"
    role="dialog"
    aria-modal="true"
    onClick={() => setPlanPreview({ open: false, planKey: null })}
  >
    {/* Overlay */}
    <div className="absolute inset-0 bg-black/40" />

    {/* Card */}
    <div
      className="relative bg-white w-full max-w-lg rounded-2xl shadow-xl overflow-hidden"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Top strip */}
      <div className={`h-1.5 ${planPreview.planKey === "PLUS" ? "bg-gradient-to-r from-sky-600 to-rose-500" : "bg-gradient-to-r from-indigo-600 to-indigo-400"}`} />

      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="text-xl font-bold text-neutral-900">
              {planPreview.planKey === "PLUS" ? translatedText.planNamePlus : translatedText.planNameBasic}
            </h3>
            <p className="text-sm text-black mt-1">
              {planPreview.planKey === "PLUS" ? translatedText.plusFeature1 : translatedText.basicFeature1}
            </p>
          </div>

          <button
            className="rounded-full border border-neutral-300 px-3 py-1 text-sm hover:bg-neutral-50"
            onClick={() => setPlanPreview({ open: false, planKey: null })}
          >
            ✕
          </button>
        </div>

        {/* Included tours grid */}
        <div className="mt-5 font-semibold">
          <div className="grid grid-cols-3 gap-2">
            {/* Regular tours */}
            {includedTours.slice(0, 6).map((t) => (
              <div key={t.id} className="bg-white border border-neutral-200 rounded-lg overflow-hidden">
                <img
                  src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${t.Image}`}
                  alt={t.name}
                  className="h-20 w-full object-cover"
                  loading="lazy"
                />
                <div className="p-2">
                  <div className="text-xs font-medium text-neutral-900 line-clamp-2">{t.name}</div>
                  <div className="text-[11px] text-neutral-600 line-clamp-1">{t.PrimaryCategory}</div>
                </div>
              </div>
            ))}
          </div>

          {includedTours.length > 6 && (
            <div className="mt-2 text-xs text-neutral-600">
              + {includedTours.length - 6} {translatedText.conjunctionAnd.toLowerCase()} {translatedText.textNextmonth.toLowerCase()}
            </div>
          )}


          {/* Divider between included tours and Fuori Rotta */}
          <hr role="separator" className="my-4 border-t border-black" />

          {/* Fuori Rotta card */}
            {fuoriCard && (
              <div className="flex justify-center mt-2">
                <div
                  className="relative bg-white border border-neutral-200 rounded-lg overflow-hidden cursor-pointer w-[70%] sm:w-[60%] max-w-[220px]"
                  onClick={() => navigate("/fuoriPreview/127981")}
                  title={fuoriCard.title}
                >
                  <img
                    src={fuoriCard.imgg}
                    alt={fuoriCard.title}
                    className="h-20 w-full object-cover"
                    loading="lazy"
                  />

                  {/* Price pill */}
                  <div className="absolute top-1 right-1 bg-white/90 text-black text-[11px] font-semibold px-1.5 py-0.5 rounded shadow">
                    🏷️ {planPreview.planKey === "PLUS" ? translatedText.textfree : "€7,99"}
                  </div>

                  <div className="p-2">
                    <div className="text-xs font-medium text-neutral-900 line-clamp-2">
                      {fuoriCard.title || translatedText.fuoriRottaTitle}
                    </div>
                    <div className="text-[11px] text-neutral-600 line-clamp-1">
                      {translatedText.fuoriRottaTitle}
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>


        {/* Footer buttons */}
        <div className="mt-6 flex items-center justify-end gap-2">
          <button
            className="rounded-full px-4 py-2 text-sm text-[#324B8E] border border-neutral-300 hover:bg-neutral-50"
            onClick={() => setPlanPreview({ open: false, planKey: null })}
          >
            {translatedText.textChiudi}
          </button>
          <button
            className="rounded-full px-4 py-2 text-sm text-white bg-[#324B8E] hover:opacity-95"
            onClick={async () => {
              await handleChoosePlan(planPreview.planKey);
              setPlanPreview({ open: false, planKey: null });
            }}
          >
            {translatedText.bundleCartBtn}
          </button>
        </div>
      </div>
    </div>
  </div>
)}













      {showSignupModal && (
        <SignupModal onClose={() => setShowSignupModal(false)} />
        )}
    </div>
  </>
  );
};

export default Choose;